import { ColorPicker } from "antd";
import { ColorEntry } from "@/utils/formatTemplate/formatTemplate";

interface DynamicColorPickerFormProps {
  value: ColorEntry[];
  onChange?: (value: ColorEntry[]) => void;
  disabled?: boolean;
}

export default function DynamicColorPickerForm({ value, onChange, disabled }: DynamicColorPickerFormProps) {
  const updateParentState = (updatedEntries: ColorEntry[]) => {
    if (onChange) {
      onChange(updatedEntries);
    }
  };

  // Handle color changes
  const handleColorChange = (index: number, colorType: "fillColor" | "textColor", colorValue: string) => {
    const updatedEntries = [...value];
    updatedEntries[index][colorType] = colorValue;
    updateParentState(updatedEntries);
  };

  return (
    <div>
      {value.map((entry, index) => (
        <div key={index} className={"flex items-center mb-4 gap-2 justify-between"}>
          <span className={" text-left pl-10 w-[240px]"}>{entry.name}</span>
          <div className={"flex gap-2.5 w-[65%]"}>
            <div className={"flex w-full gap-5 justify-around"}>
              {/* Color Picker 1 */}
              <ColorPicker
                disabled={disabled}
                showText
                format="rgb"
                value={entry.fillColor}
                onChange={(color) => handleColorChange(index, "fillColor", color.toRgbString())}
              />

              {/* Color Picker 2 */}
              <ColorPicker
                disabled={disabled}
                showText
                format="rgb"
                value={entry.textColor}
                onChange={(color) => handleColorChange(index, "textColor", color.toRgbString())}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
